module.exports = __webpack_public_path__ + "9dd66f3c3e9239d8005b5b6523eca88c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuLunchboxes.png
// module id = 413
// module chunks = 0